export default "__VITE_ASSET__C7J5JDgk__"